import { Computer, AccountBalance, BatteryChargingFull, ShoppingCart, LocalHospital, Build, Memory, Public, MonetizationOn, Domain, Security, ShowChart, Apartment } from '@mui/icons-material';

export const etfGroupConfig = [
  {
    title: "Technology",
    symbols: ["XLK", "VGT", "QQQ", "FTEC", "ARKK"],
    description: "Exposure to the leading tech companies driving innovation.",
    icon: Computer,
    color: "#4caf50" // Green
  },
  {
    title: "Financials",
    symbols: ["XLF", "VFH", "IYF", "KBE", "KRE"],
    description: "Investments in major financial institutions and banks.",
    icon: AccountBalance,
    color: "#2196f3" // Blue
  },
  {
    title: "Energy",
    symbols: ["XLE", "VDE", "IYE", "FENY", "PSCE"],
    description: "Focus on energy production, including oil, gas, and renewables.",
    icon: BatteryChargingFull,
    color: "#ff5722" // Orange
  },
  {
    title: "Consumer Discretionary",
    symbols: ["XLY", "VCR", "PEJ", "XRT", "RTH"],
    description: "Investments in companies that produce non-essential goods and services.",
    icon: ShoppingCart,
    color: "#f44336" // Red
  },
  {
    title: "Health Care",
    symbols: ["XLV", "VHT", "IBB", "XBI", "IHF"],
    description: "Exposure to companies in the health care sector, including biotech.",
    icon: LocalHospital,
    color: "#9c27b0" // Purple
  },
  {
    title: "Industrials",
    symbols: ["XLI", "VIS", "IYJ", "ITA", "FIDU"],
    description: "Focus on companies in the industrials sector, including manufacturing.",
    icon: Build,
    color: "#795548" // Brown
  },
  {
    title: "Technology Innovation",
    symbols: ["ARKW", "ARKG", "SOXX", "SKYY", "BOTZ", "CLOU", "HACK"],
    description: "Cutting-edge innovation in areas like genomics and AI.",
    icon: Memory,
    color: "#ff9800" // Amber
  },
  {
    title: "Emerging Markets",
    symbols: ["VWO", "IEMG", "EEM", "SCHE", "EEMS"],
    description: "Exposure to fast-growing economies around the globe.",
    icon: Public,
    color: "#009688" // Teal
  },
  {
    title: "Developed Markets",
    symbols: ["VEA", "IEFA", "EFA", "SCHF", "FGD"],
    description: "Investments in established economies outside the U.S.",
    icon: Public,
    color: "#3f51b5" // Indigo
  },
  {
    title: "Treasuries",
    symbols: ["TLT", "VGIT", "SHY", "IEF", "GOVT"],
    description: "U.S. government bonds for stable income and lower risk.",
    icon: MonetizationOn,
    color: "#607d8b" // Blue Grey
  },
  {
    title: "Investment-Grade Corporates",
    symbols: ["LQD", "VCLT", "VCIT", "IGIB", "IGSB"],
    description: "Bonds from high-quality corporations offering lower credit risk.",
    icon: Domain,
    color: "#4caf50" // Green
  },
  {
    title: "High-Yield Bonds",
    symbols: ["JNK", "HYG", "USHY", "ANGL", "HYLB"],
    description: "Bonds with higher yields but greater credit risk.",
    icon: MonetizationOn,
    color: "#ff5722" // Orange
  },
  {
    title: "Value ETFs",
    symbols: ["IWD", "VTV", "RPV"],
    description: "Stocks that are priced lower than their intrinsic value.",
    icon: ShowChart,
    color: "#8bc34a" // Light Green
  },
  {
    title: "Growth ETFs",
    symbols: ["VUG", "IWF", "RPG"],
    description: "Companies with strong potential for revenue growth.",
    icon: ShowChart,
    color: "#00bcd4" // Cyan
  },
  {
    title: "Dividend Growth ETFs",
    symbols: ["VIG", "DGRO", "DGRW", "NOBL"],
    description: "Companies with a history of increasing dividend payments.",
    icon: MonetizationOn,
    color: "#ffeb3b" // Yellow
  },
  {
    title: "Green/Sustainable ETFs",
    symbols: ["ICLN", "TAN", "PBW", "PBD"],
    description: "Investments in clean energy and sustainability-focused companies.",
    icon: Security,
    color: "#4caf50" // Green
  },
  {
    title: "U.S. REITs",
    symbols: ["VNQ", "SCHH", "IYR", "XLRE"],
    description: "Real estate investment trusts focused on U.S. property markets.",
    icon: Apartment,
    color: "#607d8b" // Blue Grey
  },
  {
    title: "Global REITs",
    symbols: ["VNQI", "RWX", "DRW", "RWO"],
    description: "Real estate investment trusts across global markets.",
    icon: Apartment,
    color: "#9c27b0" // Purple
  }
];
